
export function getLocalStorageObject(id) {
  let arrayOrObject = getLocalStorageArray(id);

  if (!arrayOrObject || Array.isArray(arrayOrObject)) {
    return {};
  }

  return arrayOrObject;
}

export function setLocalStorageArray(id, array) {
  window.localStorage.setItem(id, JSON.stringify(array || []));
}

export function getLocalStorageArray(id) {
  try {
    return JSON.parse(window.localStorage.getItem(id));
  } catch (e) {
    console.error(e);
    return [];
  }
}

export function maybePrefill(formID, formData, $form) {
  if (!formData.url) {
    return;
  }

  const formUrl = new URL(formData.url);
  const currentUrl = new URL(window.location.href);

  if (
    formUrl.pathname !== currentUrl.pathname ||
    formUrl.hostname !== currentUrl.hostname
  ) {
    //Not the page with the form
    return;
  }

  for (const elementName of Object.keys(formData.completedFields)) {
    const foundElements = $form.find('[name="' + elementName + '"]');

    if (!foundElements.length) {
      return;
    }

    if (elementName.includes('[]')) {
      for (const checkboxValue of formData.completedFields[elementName]) {
        const filteredElement = foundElements.filter(
          '[value="' + checkboxValue + '"]',
        );
        if (filteredElement.length) {
          filteredElement.prop('checked', true);
          filteredElement.trigger('change');
        }
      }
    } else {
      foundElements.val(formData.completedFields[elementName]);
      foundElements.trigger('change');
    }
  }

  localStorage.removeItem('gd_abandonment_f');
}
